
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const hasList = (list) => list.length > 0
  const { costCentres, effectiveDates, status } = filters

  const onSelect = createOnFilter(onFilter)

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={costCentres}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption />
        )}
        {hasList(effectiveDates) && (
          <MuiFormSelect
            id="effectiveDates"
            label="Effective Date"
            options={effectiveDates}
            value={filtered.effectiveDate}
            onChange={onSelect('effectiveDate')}
            includeEmptyOption />
        )}
        {hasList(status) && (
          <MuiFormSelect
            id="status"
            label="Status"
            options={status}
            value={filtered.status}
            onChange={onSelect('status')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
